import React, { Component } from 'react';
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form';
require(`../assets/${process.env.PAGE}/css/components/Contracts.css`)
import { Row, Col } from 'react-bootstrap';
import {FormattedHTMLMessage} from 'react-intl';
import CustomSpinner from './CustomSpinner';
import ContractContainer from '../containers/ContractContainer.js';

class Contracts extends Component {


    render() {
        const { handleSubmit, acceptedAllContracts, tos, special, liquidation } = this.props;
        return (
            <div className="terms text-center">
                <form onSubmit={handleSubmit(this.props.getStep)}>
                {this.props.isLoading &&  <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                    <h3>Consentimiento Legal</h3>
                    <FormattedHTMLMessage id="app.contract_advice" defaultMessage="<p>Por favor, abrir, leer y acordar.</p>" description="Advice"/>
                    <ContractContainer form={'tos'} onSubmit={this.props.submitContract} checked={tos} label={'Términos y Condiciones'} contractEndpoint={'/leads/contracts/tos'} />
                    <ContractContainer form={'special'} onSubmit={this.props.submitContract} checked={special} label={'Condiciones Particulares'} contractEndpoint={'/leads/contracts/special_conditions'} />
                    <ContractContainer form={'liquidation'} onSubmit={this.props.submitContract} checked={liquidation} label={'Liquidación'} contractEndpoint={'/leads/contracts/liquidation'} />
                    <Row className="terms_row">
                        <Col className="terms_col text-center" xs={12} md={12} lg={12}>
                            <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={!acceptedAllContracts} >Finalizar</button>
                        </Col>
                    </Row>
                 </form>
            </div>
        );
    }
}

const selectorTos = formValueSelector('tos')
const selectorSpecial = formValueSelector('special')
const selectorLiquidation = formValueSelector('liquidation')

Contracts = connect(
    state => {
        const tos = selectorTos(state, 'contract_accepted');
        const special = selectorSpecial(state, 'contract_accepted');
        const liquidation = selectorLiquidation(state, 'contract_accepted');
        const acceptedAllContracts = tos && special && liquidation
        return {
            tos,
            special,
            liquidation,
            acceptedAllContracts
        }
    }
)(Contracts)

Contracts = reduxForm({
    form: 'Contracts', // a unique name for this form
})(Contracts);


export default Contracts;



/** WEBPACK FOOTER **
 ** ./src/components/Contracts.js
 **/